import(/* webpackMode: "eager" */ "/vercel/path0/src/app/en/blog/page.tsx");
